import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { getDefaultLandingPageByRole } from '@orderna/admin-panel/src/utils/get-default-landing-page';
import { LocalStorageService } from '../../shared/services/local-storage.service';

export const guestGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  
  const router = inject(Router);
  const localStorage = inject(LocalStorageService);

  // ✅ IMPORTANT: check if token exists in URL
  const activationToken = route.queryParams['token'];

  // ✅ Allow access if activation/reset token is present
  if (activationToken) {
    return true;
  }

  const hasAccessToken = !!localStorage.getAccessToken();

  if (hasAccessToken) {

    const role = localStorage.getRole();
    if (!role) {
      return false;
    }

    const defaultLandingPage = getDefaultLandingPageByRole(role);
    return router.parseUrl(defaultLandingPage);
  }

  return true;
};
